import { EtatPetiteAnnonce } from "../enums/etat-petite-annonce.enum";

export const getEtatPetiteAnnonce = (etat: EtatPetiteAnnonce) => {
  switch (etat) {
    case EtatPetiteAnnonce.AttentePaiement:
      return "En attente de paiement";
    case EtatPetiteAnnonce.Payee:
      return "Envoyée pour validation";
    case EtatPetiteAnnonce.Rejetee:
      return "Refusée";
    case EtatPetiteAnnonce.Remboursee:
      return "Remboursée";
    case EtatPetiteAnnonce.Validee:
      return "Acceptée";
    default:
      return "Inconnu";
  }
};

export const getCouleurPetiteAnnonce = (etat: EtatPetiteAnnonce) => {
  switch (etat) {
    case EtatPetiteAnnonce.AttentePaiement:
      return "bg-orange-200";
    case EtatPetiteAnnonce.Payee:
      return "bg-blue-200";
    case EtatPetiteAnnonce.Rejetee:
      return "bg-red-200";
    case EtatPetiteAnnonce.Remboursee:
      return "bg-purple-200";
    case EtatPetiteAnnonce.Validee:
      return "bg-green-200";
    default:
      return "bg-gray-200";
  }
};
